import { render, staticRenderFns } from "./TorAbschlussSimulieren.vue?vue&type=template&id=6dc5b288"
import script from "./TorAbschlussSimulieren.vue?vue&type=script&lang=js"
export * from "./TorAbschlussSimulieren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports